import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';

/** Prototype toast(): one dark message at the bottom centre, gone after a moment. */
const ToastContext = createContext(() => {});

export function ToastProvider({ children, duration = 2600 }) {
  const [msg, setMsg] = useState('');
  const [shown, setShown] = useState(false);
  const timer = useRef(null);
  const toast = useCallback((text) => {
    setMsg(String(text || ''));
    setShown(true);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setShown(false), duration);
  }, [duration]);
  useEffect(() => () => clearTimeout(timer.current), []);
  return (
    <ToastContext.Provider value={toast}>
      {children}
      <div className={`wz-toast${shown ? ' show' : ''}`} role="status" aria-live="polite">{msg}</div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  return useContext(ToastContext);
}
